import FieldDataIdentifier from 'automation-ui-flow-core/fields/FieldDataIdentifier';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { Map as ImmutableMap, Record } from 'immutable';
import setIn from 'immutable-less/transmute/setIn';
export default class StaticBranchInput extends Record({
  type: PropertyValueTypes.OBJECT_PROPERTY,
  propertyName: '',
  propertyToken: '',
  value: '',
  identifier: null
}) {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const {
      identifier
    } = props;
    super(propMap.set('identifier', identifier ? new FieldDataIdentifier(identifier) : null));
  }
  getType() {
    return this.type;
  }
  setType(type) {
    return this.set('type', type);
  }
  getPropertyName() {
    return ['ENROLLMENT_EVENT_PROPERTY', 'FETCHED_OBJECT_PROPERTY', 'OBJECT_PROPERTY', 'STATIC_VALUE'].includes(this.type) ? this.propertyName : this.getDataKey();
  }
  setPropertyName(name) {
    return this.set('propertyName', name);
  }
  getIdentifier() {
    return this.type === 'FIELD_DATA' ? this.identifier : null;
  }
  setIdentifier(identifier) {
    return this.set('identifier', identifier);
  }
  getTargetActionId() {
    var _this$identifier;
    return (_this$identifier = this.identifier) === null || _this$identifier === void 0 ? void 0 : _this$identifier.actionId;
  }
  setTargetActionId(id) {
    return setIn(['identifier', 'actionId'], id, this);
  }
  getDataKey() {
    var _this$identifier2;
    return (_this$identifier2 = this.identifier) === null || _this$identifier2 === void 0 ? void 0 : _this$identifier2.dataKey;
  }
  getValue() {
    return this.value;
  }
  setValue(value) {
    return this.set('value', value);
  }
  getPropertyToken() {
    return this.propertyToken;
  }
  setPropertyToken(propertyToken) {
    return this.set('propertyToken', propertyToken);
  }
}